import { useState } from 'react'

import { EuiButton } from '@equipmentshare/ds2'

import useCancelTransactionHandler from 'views/reports/effects/cancel-transaction'

import styles from '../ProcessingStatus/processing-status.module.css'

export type ConfirmCancelTransactionProps = {
	transaction: { id: number },
	closeConfirm: () => void,
}

export default function ConfirmCancelTransaction( { closeConfirm, transaction }: ConfirmCancelTransactionProps ) {
	const [ isSaving, setIsSaving ] = useState( false )
	const cancelTransaction = useCancelTransactionHandler()
	const transactionId = transaction.id

	const onConfirmClick = async() => {
		setIsSaving( true )
		try {
			await cancelTransaction( transactionId )
		} catch ( e ) {
			setIsSaving( false )
		}
	}

	return (
		<div className={styles.actionPopover}>
			<h3>Are you sure you want to cancel this transaction?</h3>
			<div className={styles.buttonWrapper}>
				<EuiButton
					color="text"
					onClick={closeConfirm}
				>
					Cancel
				</EuiButton>
				<EuiButton
					color="danger"
					fill
					id="confirm-btn"
					isLoading={isSaving}
					onClick={onConfirmClick}
				>
					Confirm
				</EuiButton>
			</div>
		</div>
	)
}
